var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        "v-menu",
        {
          attrs: { "offset-y": "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b({ attrs: { text: "" } }, "v-btn", attrs, false),
                      on
                    ),
                    [
                      _c("v-icon", {
                        staticClass: "mr-5 primary--text",
                        attrs: { left: "", large: "" },
                        domProps: { textContent: _vm._s("mdi-account-circle") }
                      }),
                      _vm._v("\n        Account\n        "),
                      _c("v-icon", {
                        staticClass: "ml-3 primary--text",
                        attrs: { right: "", small: "" },
                        domProps: {
                          textContent: _vm._s("mdi-chevron-down-circle")
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            { attrs: { rounded: "" } },
            [
              _c("v-subheader", [
                _vm._v(
                  "User: " +
                    _vm._s(this.$auth.user.firstName) +
                    "\n        " +
                    _vm._s(this.$auth.user.lastName)
                )
              ]),
              _vm._v(" "),
              _c(
                "v-list-item-group",
                [
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "NuxtLink",
                            {
                              staticStyle: {
                                "text-decoration": "inherit",
                                color: "inherit"
                              },
                              attrs: { to: "/edit-profile" }
                            },
                            [_vm._v("Edit Profile")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", {
                            domProps: { textContent: _vm._s("Logout") },
                            on: { click: _vm.handleLogout }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }